import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import InputMask from 'react-input-mask'
import { Redirect } from 'react-router-dom'

@observer
class Passenger extends Component {
  state = {
    showForm: false,
    name: '',
    phone: '',
  }

  showFormStatus = () => {
    this.setState({
      showForm: !this.state.showForm,
    })
  }

  chgInp = evt => {
    this.setState({
        [evt.target.name]: evt.target.value,
    })
  }

  saveClient = () => {
    if(this.state.phone  < 13) {
      this.showFormStatus()
    } else {
      this.props.setAnotherPassenger(this.state.name, this.state.phone)
      this.showFormStatus()
    }
  }

  render() {
    const {anotherPassengerName, anotherPassengerPhone} = this.props
    if(!this.props.clientInfo){
      localStorage.removeItem('PHPSESSID')
      return <Redirect to="/" />
    }
    const {varFirstName, varLastName, varTel} = this.props.clientInfo 

    const clientName = anotherPassengerName ? anotherPassengerName : `${varFirstName} ${varLastName}`
    const clientPhone = anotherPassengerPhone ? anotherPassengerPhone : varTel

    const addAnotherClient = this.state.showForm ?
     (
       <div className="row passenger-data another-client">
         <div className="col-12" style={{paddingBottom: "10px"}}>
          <input className="form-control webcab-field" type="text" name="name" placeholder="Имя пассажира" value={this.state.name} onChange={this.chgInp} />
         </div>
         <div className="col-10">
         <InputMask className="form-control webcab-field"  placeholder="+380 (99) 999-99-99" mask="+380 (99) 999-99-99" type="text" name="phone" maskChar={null} value={this.state.phone} onChange={this.chgInp} />
         </div>
         <div className="col-2">
           <button className="btn btn-another-pass" onClick={this.saveClient}>OK</button>
         </div>
       </div>
     )

     : (
      <div className="row passenger-data">
        <div className="col-8 passenget-data__info">
          {clientName}<br />
          {clientPhone}
        </div>
        <div className="col-4 another-passenger" onClick={this.showFormStatus}>
          <span>Другой пассажир</span>
          <i className="passenger-data__icon user-icon icons">с</i>
        </div>
      </div>
     )
    return (
      <>{addAnotherClient}</>
    )
  }
}

const withData = inject(stores => ({
  clientInfo: stores.LoginFromStore.clientInfo,
  anotherPassengerName: stores.OrderStore.anotherPassengerName,
  anotherPassengerPhone: stores.OrderStore.anotherPassengerPhone,
  setAnotherPassenger: stores.OrderStore.setAnotherPassenger,
}))

export default withData(Passenger);